import React, { Fragment, useState } from "react";
import { MdCloudUpload, MdDelete, MdCreate } from "react-icons/md";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import axios from "axios";
import { config_url } from "../../config";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  height: "50vh",

  border: "2px solid #000",
  borderRadius: "12px",
  boxShadow: 24,
  overflowY: "scroll", // This will add a vertical scrollbar

  p: 4,
};

function AffectedImageToJob({ closeModal, rowJob }) {
  const [image_categoty, setImageCategory] = useState("");
  const [fileName, setFileName] = useState("No selected file");
  const [meta_image_category, setMetaImage] = useState("");

  const handleUpload = async (e) => {
    e.preventDefault();

    const formdata = new FormData();
    formdata.append("image_vacance", image_categoty);
    formdata.append("meta_image_category", meta_image_category);
    formdata.append("job_id", rowJob.id);

    try {
      const response = await axios.post(
        `${config_url}/api/affected-image-job`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Affected Image Success !!", {
          position: "top-right",
        });
        closeModal();
      }

      console.log(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <Fragment>
      <Modal
        open={true} // Modal is controlled by parent component
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full bg-gray-100 p-2 mb-4">
            <Typography variant="h5" gutterBottom>
              Affect image to Job
            </Typography>
          </div>
          <Divider />
          <div className="m-10">
            <div
              className="form"
              onClick={() => document.querySelector(".input-field").click()}
            >
              <input
                type="file"
                className="input-field"
                hidden
                onChange={({ target: { files } }) => {
                  files[0] && setFileName(files[0].name);
                  if (files) {
                    setImageCategory(files[0]);
                  }
                }}
              />

              {image_categoty ? (
                <img
                  className="w-[150px] h-[150px] rounded-full border-2 border-gray-400"
                  src={image_categoty && URL.createObjectURL(image_categoty)}
                  width={150}
                  height={150}
                  alt={fileName}
                />
              ) : (
                <>
                  <MdCloudUpload color="#1475cf" size={60} />
                  <p>Upload Image to Affected for Job </p>
                </>
              )}
            </div>
          </div>
          <Divider />
          <div className="right-0 mt-4 flex">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<MdCreate />}
              onClick={(e) => handleUpload(e)}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>
      <div></div>
    </Fragment>
  );
}

export default AffectedImageToJob;
